import { call } from 'redux-saga/effects';
import { checkRequestIsOk, checkRequestStatus } from '../utils';

export function* serverRequestSaga(apiCall, request, docId, version) {
  const signRequest = yield call(apiCall, request, docId, version);
  checkRequestIsOk(signRequest);
  checkRequestStatus(signRequest);
}
